import { useEffect, useState } from "react";

/**
 * Handy-Breite (unter 768 px, dieselbe Grenze wie die Karten-Listen in den Stylesheets) als React-Zustand, damit Seiten
 * dort anders aufbauen können (Umbauten 03.11.2026: Abschnitte eingeklappt, kleinere Seiten). Ohne Fenster (Tests auf dem
 * Server) gilt „kein Handy“.
 */
export const HANDY_ABFRAGE = "(max-width: 767px)";

export function istHandy(): boolean {
  return typeof window !== "undefined" && !!window.matchMedia?.(HANDY_ABFRAGE).matches;
}

export function useHandy(): boolean {
  const [handy, setHandy] = useState(istHandy);
  useEffect(() => {
    const mq = window.matchMedia?.(HANDY_ABFRAGE);
    if (!mq) return;
    const lesen = () => setHandy(mq.matches);
    lesen();
    mq.addEventListener("change", lesen);
    return () => mq.removeEventListener("change", lesen);
  }, []);
  return handy;
}
